import { jsx as _jsx } from "tsx-dom/jsx-runtime";
export function DynamicStyles() {
    return (_jsx("style", { id: "dynamic-styles" }));
}
